import React, { useContext } from 'react'

import { Container, DatesVariant, renderImage } from './Common'

import TripItemSummary from 'tripPlanner/components/TripModal/TripItems/Summary'
import TripContext from 'tripPlanner/contexts/TripContext'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { CarRentalItem } from 'tripPlanner/types/tripItem'
import { typeConstToTitle } from 'tripPlanner/utils'

interface Props {
  item: CarRentalItem
}

const CarRentalSummaryCard = React.forwardRef<HTMLDivElement, Props>(
  ({ item }, ref) => {
    const {
      startPlace,
      isBooked,
      carType,
      type,
      startDate,
      endDate,
      startDay,
      endDay,
    } = item

    const openModal = useOpenModal()

    const onClick = () => openModal(TripItemSummary, { item })
    const tripContext = useContext(TripContext)
    const canEdit = tripContext?.permissions.canEdit ?? false

    return (
      <Container ref={ref}>
        {renderImage(startPlace)}
        <DatesVariant
          region={undefined}
          name={carType || typeConstToTitle(type)}
          startDate={startDate}
          endDate={endDate}
          isBooked={isBooked}
          type={type}
          onClick={onClick}
          canEdit={canEdit && !isBooked}
          startDay={startDay}
          endDay={endDay}
        />
      </Container>
    )
  },
)

export default CarRentalSummaryCard
